var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinanceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 30.9375L5.625 36.45V20.625H11.25V30.9375ZM20.625 27.4875L17.6813 24.975L15 27.45V13.125H20.625V27.4875ZM30 24.375L24.375 30V5.625H30V24.375ZM35.2687 24.0188L31.875 20.625H41.25V30L37.8937 26.6437L24.375 40.05L17.8687 34.3875L10.7812 41.25H5.625L17.7563 29.3625L24.375 34.95",
    fill: "#F58220"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinanceIcon);
export default __webpack_public_path__ + "static/media/financeIcon.713f7766be5491ecdc5c40d39f5479ed.svg";
export { ForwardRef as ReactComponent };